import { createClient } from "@supabase/supabase-js";
import { navigatorLock } from "@supabase/gotrue-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
    throw new Error(
        "Missing required environment variables: " +
        [!supabaseUrl && "REACT_APP_SUPABASE_URL", !supabaseKey && "REACT_APP_SUPABASE_ANON_KEY"]
            .filter(Boolean)
            .join(", ")
    );
}

// Disable supabase-js's automatic refresh-token rotation. The legacy axios
// interceptor (src/config/interceptor.js) is now the single owner of refresh,
// going through the Next.js proxy /api/legacy/token/refresh. If the SDK also
// rotated tokens, the two refresh paths would race for the same refresh_token
// — whichever loses gets a 401 from Supabase and force-logs the user out.
// persistSession=true keeps the SDK's session readable so direct supabase.*
// calls (e.g. AccountService signInWithPassword bootstrap) still work.
// `lock: navigatorLock` opts the SDK into the Web Locks API so concurrent
// refreshSession() calls across tabs of the same origin are serialized.
// Without this, gotrue defaults to `lockNoOp` which only serializes within a
// single JS context — two tabs hitting refresh in the same millisecond would
// both spend the single-use Supabase refresh_token and the loser would 401.
// Verified at gotrue-js@2.56.0: SupabaseClient does NOT pass a lock by default.
export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        autoRefreshToken: false,
        persistSession: true,
        detectSessionInUrl: false,
        lock: navigatorLock,
    },
});

// Deprecated: kept as a no-op for API compatibility with existing callers
// (AccountService.js). supabase-js now owns its own storage; there is nothing
// to sync. See PR fix/cra-supabase-dual-storage for the dual-storage bug
// this previously tried (and failed) to mitigate.
export const updateSupabaseSession = async () => {
    // intentionally empty
};
